import React from 'react';
import { Link } from '@ontruck/orc';

import Footer from 'pages/Login/footer';
import { OnTruckLogo } from 'refactored/ui/icons';

const ErrorPage = ({ className, t }) => (
  <div className={className}>
    <section className="main" role="main">
      <OnTruckLogo />
      <p className="info">{t('info')}</p>
      <p>
        {t('contact')}
        <Link
          href={`mailto:${t('contact_link')}`}
          target="_blank"
          text={t('contact_link')}
        />
      </p>
    </section>
    <Footer t={t} />
  </div>
);

export default ErrorPage;
